// Single source of truth for the floating bottom nav's footprint, so every
// page/FAB that needs to clear it derives the same numbers instead of
// independently guessing a pixel offset.

export const NAV_HEIGHT = 56;
export const NAV_MARGIN = 16;
const FAB_GAP = 16;

// Bottom nav: `bottom: 16` + safe-area inset, so it never sits under the
// iOS home-indicator.
export const NAV_BOTTOM_OFFSET = `calc(env(safe-area-inset-bottom) + ${NAV_MARGIN}px)`;

// FABs: clear the nav's height + its own margin + a visual gap above it.
export const FAB_BOTTOM_OFFSET = `calc(env(safe-area-inset-bottom) + ${
  NAV_HEIGHT + NAV_MARGIN + FAB_GAP
}px)`;

// Page content: leave room for the floating nav so the last list item isn't
// hidden behind it.
export const CONTENT_BOTTOM_PADDING = `calc(env(safe-area-inset-bottom) + 112px)`;

export const CONTENT_TOP_PADDING = 'env(safe-area-inset-top)';
